<template>
  <div class="layout-inner">
    <navbar></navbar>
    <div class="layout-container">
      <div class="layout-content">
        <template v-if="isLoading">
          <div class="w-100" style="padding: 150px 0;">
            <spinner size="large"></spinner>
          </div>
        </template>
        <template v-else>
          <template v-if="career && career.name">
            <career-title :career="career"></career-title>
          </template>
          <div class="container-fluid flex-grow-1 pg_content_container">
            <explore-insight-list :type="'insights'" :isAlumniInsights="'true'" v-if="!isLoading"></explore-insight-list>
          </div>
        </template>
        <career-footer-navbar :pageTitle="'Alumni Insights'" :returnTo="'careerHome'" :params="{isComingFromBookmark: isComingFromBookmark}"></career-footer-navbar>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import CareerTitle from './CareerTitle'
  import Navbar from '../../misc/components/./Navbar'
  import CareerFooterNavbar from '../../misc/components/./CareerFooterNavbar'
  import ExploreInsightList from '../../explore/components/ExploreInsightList'

  export default {
    name: 'career-alumni-insights',
    props: ['code', 'isComingFromBookmark'],
    components: {
      Navbar,
      CareerTitle,
      CareerFooterNavbar,
      ExploreInsightList
    },
    data: () => {
      return {
        isLoading: true
      }
    },

    mounted () {
      this.loadDataForCareerAlumniInsights()
    },

    methods: {
      ...mapActions([
        'loadCareer',
        'setCurrentFacet'
      ]),
      async loadDataForCareerAlumniInsights () {
        await this.loadCareer(this.code)
        this.setCurrentFacet('insights')
        this.isLoading = false
      }
    },
    computed: {
      ...mapState({
        'career': state => state.career.careerObject
      })
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/app/career/components/CareerAlumniInsights.vue